import state from './moduleNewsState'
import actions from './moduleNewsActions'
import getters from './moduleNewsGetters'
import mutations from './moduleNewsMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

